<template>
    <div class="wrapper">
        <div class="number-line">
            <span class="stat">
                {{ countersFormat(stat) }}
            </span>
            <div v-if="percent" class="percent" v-tooltip.bottom="{
                value: t('global.compareYesterday'),
                pt: {
                    text: '!bg-primary text-xs',
                },
            }" type="text" placeholder="Bottom">
                <span v-if="percent">{{ percent }}%</span>
                <Icon name="trending-up" class="icon" v-if="percent > 0 && percent" />
                <Icon name="trending-down" class="icon" v-else-if="percent < 0 && percent" />
            </div>
        </div>
    </div>
</template>

<script setup>
import { countersFormat } from '@utils';
import { useI18n } from 'vue-i18n';

const { t } = useI18n({ useScope: 'global' });

const { title, stat } = defineProps({
    stat: {
        type: Number,
        default: 0,
    },
    percent: {
        type: Number,
        default: 0,
    },
});
</script>

<style scoped>
.wrapper {
    @apply flex flex-col gap-y-2 select-none overflow-hidden;
}

.title {
    @apply text-[--main-black] tracking-wide;
}

.stat {
    @apply font-semibold text-2xl tracking-wider;
}

.number-line {
    @apply flex items-center justify-between;
}

.icon {
    @apply size-4;
}

.percent {
    @apply flex gap-x-1 items-center text-xs;
}

:deep(.p-tooltip-text) {
    @apply text-xs !important;
}
</style>
